import { Box, Container } from "@mui/material";
import React from "react";

import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import Paper from "@mui/material/Paper";
import { StyledTableCell, StyledTableRow } from "./TableCell";
import TableRow from "@mui/material/TableRow";

function createData(created_on, receiver, amount_paid, balance, due_date) {
  return { created_on, receiver, amount_paid, balance, due_date };
}

const rows = [
  createData("12/09/22", "0ooxo..ox9", "45000", "5000", "14/09/22"),
  createData("12/09/22", "0ooxo..ox9", "45000", "5000", "14/09/22"),
  createData("12/09/22", "0ooxo..ox9", "45000", "5000", "14/09/22"),
  createData("12/09/22", "0ooxo..ox9", "45000", "5000", "14/09/22"),
  createData("12/09/22", "0ooxo..ox9", "45000", "5000", "14/09/22"),
];

const RentPaidTable= () => {
  return (
    <Box sx={{ backgroundColor: "#E4E6E6", pt: "7%", minHeight: "100vh" }}>
      <Container maxWidth="lg">
        
       
        <Box sx={{ mt: "4%" }}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Time / Day</StyledTableCell>
                  <StyledTableCell align="right">
                  Receiver's Address
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    Amount Paid
                  </StyledTableCell>
                  <StyledTableCell align="right">
                  Balance
                  </StyledTableCell>
                  <StyledTableCell align="right">Due Date</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <StyledTableRow key={row.created_on}>
                    <StyledTableCell component="th" scope="row">
                      {row.created_on}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {row.receiver}
                    </StyledTableCell>
                    <StyledTableCell align="right">{row.amount_paid}</StyledTableCell>
                    <StyledTableCell align="right">{row.balance}</StyledTableCell>
                    <StyledTableCell align="right">
                      {row.due_date}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Container>
    </Box>
  );
};

export default RentPaidTable;
